import { render } from "./LocationDashboard.vue?vue&type=template&id=a47c447c&scoped=true"
import script from "./LocationDashboard.vue?vue&type=script&lang=js"
export * from "./LocationDashboard.vue?vue&type=script&lang=js"

import "./LocationDashboard.vue?vue&type=style&index=0&id=a47c447c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47c447c"]])

export default __exports__